/**
 * Feature flags configuration for controlling application features
 * @typedef {Object} FeatureFlag
 * @property {boolean} enabled - Whether the feature is currently enabled
 * @property {string} description - Description of what the feature does
 * @property {string} disabledByTicket - Jira ticket that disabled/hid the feature
 * @property {string} enableTicket - Jira ticket for implementing and enabling the feature
 */

/**
 * Application feature flags
 * @type {Object.<string, FeatureFlag>}
 */
export const FEATURE_FLAGS = {
    /**
     * Controls editing functionality for TCDS system meshbots
     * @type {FeatureFlag}
     */
    TCDS_SYSTEM_MESHBOT_EDITING: {
        enabled: false,
        description: 'Enable editing for TCDS system meshbots',
        disabledByTicket: 'ENWT-5263', // The ticket that hid the feature
        enableTicket: 'ENWT-5265', // Ticket for implementation and opening
    },
};
